





import {apiV1AdminStaffBlogPath} from '@/rails/routes'
import {Component} from 'vue-property-decorator'
import PostForm from '@/components/admin/PostForm.vue'
import PostEdit from '@/components/admin/PostEdit'
import Post, {IPost} from '@/models/Post'
import StaffBlog, {IStaffBlog} from '@/models/StaffBlog'
import {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    PostForm
  }
})
export default class StaffBlogEdit extends PostEdit {
  async mounted(): Promise<void> {
    this.targetPath = apiV1AdminStaffBlogPath(this.$route.params.id)
    return super.mounted()
  }

  toFrontModel(data: IPost): Post {
    return new StaffBlog(data as IStaffBlog)
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'スタッフブログ一覧',
        to: '/admin/staff_blogs',
        exact: true
      },
      {
        text: 'スタッフブログ編集'
      }
    ]
  }
}
